import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase/firebase-config";
import VerifiedAddressPanel from "./VerifiedAddressPanel";

const Metro = () => {
  const [identity, setIdentity] = useState({ userId: auth.currentUser?.uid || "", revision: 0 });

  useEffect(() => onAuthStateChanged(auth, (user) => {
    const userId = user?.uid || "";
    setIdentity((current) => current.userId === userId ? current : { userId, revision: current.revision + 1 });
  }), []);

  return (
    <section className="metro-list-page" aria-labelledby="verified-addresses-title">
      <Link className="metro-list-back" to="/dashboard">← Dashboard</Link>
      <VerifiedAddressPanel key={`${identity.userId}:${identity.revision}`} userId={identity.userId} />
    </section>
  );
};

export default Metro;
